import html2canvas from "html2canvas";

async function pdfDOMMakeFunc2 ( targetElement, a4heignt ) {
  const targetRect = targetElement.getBoundingClientRect();
  const a4W = 1200;
  // const a4H = 1587;
  const a4H = (a4heignt || a4W * 1.3);
  const imageList = [];
  const canvasList = [];
  const cropCanvas = document.createElement('canvas');
  const cropCtx = cropCanvas.getContext('2d');

  let sizeList = [0];
  let page = 1;
  let pageHeight = 0;

  const options = {
    type : 'dataURL' ,
    scale : 1 ,
    allowTaint : false ,
    backgroundColor: '#fff',
    useCORS : true ,
    logging : true,
    width: a4W,
    height: targetRect.height,
    scrollX: 0, scrollY: 0,
    x:0, y:0,
    foreignObjectRendering: true,
    ignoreElements: (element) =>{
      let nodeName = element.nodeName.match(`P|IMG|TR|H1|H3`);
      if(nodeName && nodeName.index === 0 ) {
        let rect = element.getBoundingClientRect();
        if(rect.bottom > (pageHeight + a4H)){
          // console.log(element, pageHeight, targetRect.height, rect, page);
          pageHeight = rect.top;
        }
      }
    }
  } ;

  const canvas = await html2canvas(targetElement, options);
  sizeList.push(targetRect.height);
  cropCanvas.width = canvas.width;
  cropCanvas.height = a4H;
  canvasList[0] = canvas;

  for(let i=1; i<sizeList.length; i++) {
    let y = sizeList[i-1];
    let size = sizeList[i] - y;
    cropCtx.fillStyle = '#ffffff';
    cropCtx.fillRect(0,0,cropCanvas.width, cropCanvas.height);
    cropCtx.drawImage(canvas, 0, y, a4W, size, 0, 0, a4W, size);
    imageList.push(cropCanvas.toDataURL('image/jpeg'));
  }

  return {imageList, canvasList};
}

export default pdfDOMMakeFunc2;
